import React from "react";
import { PageLayout } from "../../components/ui";
import { List } from "lucide-react";

type props = {
    children: React.ReactNode;
};

const Transactions = ({ children }: props) => {
    return (
        <PageLayout heading="Operations" icon={List}>
            {children}
        </PageLayout>
    );
};

export default Transactions;
